import React from 'react';
import { inject, observer } from 'mobx-react';
import { FlightDetailStore, WeatherStore } from '@move-frontend/dap';
import styled from '@emotion/styled';
import { IEnrichedFlightProps } from '../../shared/flight/domain/models/IEnrichedFlight';

import { IFlight } from '../../shared/flight/domain/models/IFlight';
import { FlightDetailNoResult } from './FlightDetailNoResult';
import { FlightDetailHighlight } from './FlightDetailHighlight';
import { FlightDetailLoading } from './FlightDetailLoading';
import { SolidContentWrap } from '../../../shared/components';
import { IStores } from '../../../app/root/domain/stores/createStores';
import { parseFlightDetailsHash } from './helpers/flightDetailsUrl';
import { getCurrentHash } from '../../../shared/router/utils/getCurrentHash';
import Responsive from '../../../../ui/utils/Responsive';

interface IProps {
	highlightImage?: string;
}

interface IInjectedProps extends IProps {
	flightDetailStore: FlightDetailStore<IFlight, IEnrichedFlightProps>;
	weatherStore: WeatherStore;
}

interface IState {
	invalidHash: boolean | undefined;
}

export const StyledSolidContentWrap = styled(SolidContentWrap)`
	padding: 0px;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		padding: 0px;
	}
`;

export const FlightDetailContent = inject(
	({ flightDetailStore, weatherStore }: IStores) => ({
		flightDetailStore,
		weatherStore,
	}),
)(
	observer(
		class FlightDetailContent extends React.Component<IProps, IState> {
			public state = {
				invalidHash: undefined,
			};

			protected get injected() {
				return this.props as IInjectedProps;
			}

			public componentDidMount() {
				window.scrollTo(0, 0);
				const hash = getCurrentHash();
				const params = parseFlightDetailsHash(hash);

				this.setState({
					invalidHash: params === false,
				});

				if (params === false) {
					return;
				}

				this.injected.flightDetailStore.load(params);
				this.injected.weatherStore.load(params.arrivalAirport);
			}

			public componentWillUnmount() {
				this.injected.flightDetailStore.clear();
			}

			public renderDetailHighlight() {
				const { invalidHash } = this.state;

				if (invalidHash) {
					return <FlightDetailNoResult />;
				}

				const { flightDetailStore, weatherStore } = this.injected;

				if (
					!flightDetailStore.finishedInitialLoad ||
					!weatherStore.finishedInitialLoad ||
					flightDetailStore.isLoading ||
					weatherStore.isLoading
				) {
					return <FlightDetailLoading />;
				}

				if (!flightDetailStore.flight) {
					return <FlightDetailNoResult />;
				}

				const { highlightImage } = this.props;

				return (
					<FlightDetailHighlight
						flight={flightDetailStore.flight}
						weather={weatherStore.weather}
						highlightImage={highlightImage}
					/>
				);
			}

			public render() {
				return (
					<StyledSolidContentWrap>
						{this.renderDetailHighlight()}
					</StyledSolidContentWrap>
				);
			}
		},
	),
);
